/* -------------------------------------------------------------------------- */
/*                                dependencies                                */
/* -------------------------------------------------------------------------- */
// packages
import React from "react";
import { Routes as Switch, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
// Local UI components
import DashboardView from "../Views/DashboardView";
import MonEquipeView from "../Views/MonEquipeView";
import ProduitsView from "../Views/ProduitsView";
import ProductDetails from "../Components/Catalogue/ProductDetails/ProductDetails";
import PanierDetails from "../Components/Catalogue/PanierDetails/PanierDetails";
import DeliveryDetails from "../Components/Catalogue/DeliveryDetails/DeliveryDetails";
import CommandesView from "../Views/CommandesView";
import ApporteurAffaires from "../Views/ApporteurAffaires";
import RevendeurView from "../Views/RevendeurView";
import ProspectsView from "../Views/ProspectsView";
import AppCustomersView from "../Views/AppCustomersView";
import IntermediaresProfiles from "../Components/Revendeur/IntermediaresProfiles/IntermediaresProfiles";
import CalendarView from "../Views/CalendarView";
import FaqView from "../Views/FaqView";
import MainFacturesView from "../Views/MainFacturesView";
import SavView from "../Views/SavView";
import CatalogueNewView from "../Views/CatalogueNewView";
import PayementSuccess from "../Components/Catalogue/PaymentDetails/PayementSuccess";
import PayementFail from "../Components/Catalogue/PaymentDetails/PayementFail";
import CurrentAvoirsView from "../Views/CurrentAvoirsView";
// import AvoirView from "../Views/AvoirView";
import ForgotPassword from "../Views/ForgotPassword";
import ResetPasswordCode from "../Views/ResetPasswordCode";
import DepartureView from "../Views/DepartureView";
import DeliveryView from "../Views/DeliveryView";
import ProspectUsers from "../Components/Prospects/ProspectUsers";
import LogisticsView from "../Views/LogisticsView";
import PartnersView from "../Views/PartnersView";
import IaAdminView from "../Views/IaAdminView";

const Routes = () => {
  /* ****************************** CONSTS & VARS ***************************** */
  const { userRole, user } = useSelector((state) => state.userReducer);
  /* ******************************** Rendering ******************************* */

  if (user?.attributes?.userRole === 3) {
    return (
      <Switch>
        <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
        <Route
          path="/mot-de-passe-oublie/reset"
          element={<ResetPasswordCode />}
        />
        <Route path="/livraison" element={<DepartureView />} />
        <Route path="*" element={<Navigate to="/livraison" />} />
      </Switch>
    );
  }
  if (user?.attributes?.userRole === 4) {
    return (
      <Switch>
        <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
        <Route
          path="/mot-de-passe-oublie/reset"
          element={<ResetPasswordCode />}
        />
        <Route path="/livraison" element={<DeliveryView />} />
        <Route path="*" element={<Navigate to="/livraison" />} />
      </Switch>
    );
  }
  // A store's commercial: the catalogue (stock, public prices — it doesn't
  // order), the orders it follows, its customers.
  if (user?.attributes?.userRole === 7) {
    return (
      <Switch>
        <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
        <Route
          path="/mot-de-passe-oublie/reset"
          element={<ResetPasswordCode />}
        />
        <Route path="/catalogue" element={<CatalogueNewView />} />
        <Route path="/catalogue/produit/:id" element={<ProductDetails />} />
        <Route path="/commandes" element={<CommandesView />} />
        <Route path="/clients-app" element={<AppCustomersView />} />
        <Route path="/guide" element={<FaqView />} />
        <Route path="*" element={<Navigate to="/clients-app" />} />
      </Switch>
    );
  }

  return (
    <Switch>
      <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
      <Route
        path="/mot-de-passe-oublie/reset"
        element={<ResetPasswordCode />}
      />

      <Route path="/" exact element={<DashboardView />} />
      {userRole === "admin" && (
        <>
          <Route path="/catalogue" element={<CatalogueNewView />} />
          <Route path="/avoirs/editer" element={<CurrentAvoirsView />} />
          <Route path="/produits" element={<ProduitsView />} exact />
          <Route path="/logistics" element={<LogisticsView />} />
          <Route path="/partenaires" element={<PartnersView />} />
          <Route path="/assistant-ia" element={<IaAdminView />} />
        </>
      )}
      {userRole !== "businessBroker" && (
        <Route path="/equipe" exact element={<MonEquipeView />}></Route>
      )}
      {user?.attributes?.userRole === 0 && (
        <>
          <Route path="/livraison" element={<DeliveryView />} />
          <Route path="/facture" element={<MainFacturesView />} />
        </>
      )}
      {user?.attributes?.userRole === 2 && (
        <>
          <Route path="/livraison" element={<DepartureView />} />
          <Route path="/facture" element={<MainFacturesView />} />
          <Route path="/partenaires" element={<PartnersView />} />
        </>
      )}
      <Route path="/catalogue" element={<CatalogueNewView />} exact />
      <Route path="/catalogue/produit/:id" element={<ProductDetails />} />
      <Route path="/catalogue/panier" element={<PanierDetails />} />
      <Route path="/catalogue/livraison" element={<DeliveryDetails />} />
      <Route path="/commandes" element={<CommandesView />} />
      <Route path="/apporteur-affaires" element={<ApporteurAffaires />} />
      <Route path="/revendeur" element={<RevendeurView />} />
      {[0, 1, 2].includes(user?.attributes?.userRole) && (
        <Route path="/clients-app" element={<AppCustomersView />} />
      )}
      <Route path="/prospects" element={<ProspectsView />} />
      <Route path="/prospects/:id/profils" element={<ProspectUsers />} />
      <Route
        path="/revendeur/:id/profils"
        element={<IntermediaresProfiles />}
      />
      <Route path="/calendrier" element={<CalendarView />} />
      <Route path="/guide" element={<FaqView />} />
      <Route path="/SAV" element={<SavView />} />
      <Route path="/paiement-succes" element={<PayementSuccess />} />
      <Route path="/paiement-echec" element={<PayementFail />} />
      <Route path="*" exact element={<Navigate to="/" />} />
    </Switch>
  );
};
export default Routes;
